import { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { authGuard, authLoginGuard, setupGuard } from '@DataFriends-Group/ngx-core';
import { inject } from '@angular/core';
import { StartUpService } from './service/start-up.service';

const api = {
  protocol: environment.api.protocol ?? location.protocol,
  hostname: environment.api.hostname ?? location.hostname,
  port: environment.api.port ?? location.port,
};

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./page/login-page/login-page.component').then((m) => m.LoginPageComponent),
    canActivate: [setupGuard, authLoginGuard],
    resolve: { startup: () => inject(StartUpService).startUpLogin() },
    data: api,
  },
  {
    path: 'base',
    loadChildren: () => import('./page/base-page/routes').then((m) => m.routes),
    canActivate: [setupGuard, authGuard],
    data: api,
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
